// Plan 08-07 / Plan 09-02 / Plan 09-03 / Plan 17-07 — site-wide Footer.
//
// Plan 09-03 LOCK: Footer is mounted OUTSIDE the <Router> tree (sibling of
// the route table in main.tsx), so calling the router hook inline throws
// "router context not found". The fix routes navigation through the
// module-level `navigateTo` bridge in router/nav.ts — the same shim
// AuthProvider uses for the identical above-the-Router predicament.
// PRESERVED VERBATIM BY PLAN 17-07: do NOT swap to the React-Router hook.
//
// Plan 17-07 re-skin: 1-line chrome — version text + locale Chip + 2 Btn
// links (Privacy / Terms). All visual literals tokenized. The
// data-testid="site-footer" attribute is PRESERVED — existing Playwright
// e2e selectors depend on it.

import { useStore } from '@nanostores/react'
import type { JSX } from 'react'
import { FormattedMessage } from 'react-intl'

import { navigateTo } from '../../router/nav.js'
import { $locale } from '../../stores/locale.js'
import { Btn } from '../components/Btn.js'
import { Chip } from '../components/Chip.js'

export function Footer(): JSX.Element {
  const locale = useStore($locale)
  return (
    <footer
      className="site-footer"
      data-testid="site-footer"
      data-screen-region="footer"
      role="contentinfo"
      style={{
        padding: 'var(--space-2) var(--space-4)',
        fontSize: 'var(--font-size-11)',
        color: 'var(--color-text-tertiary)',
        background: 'var(--color-bg-deep)',
        borderTop: '1px solid var(--color-surface-stroke)',
        display: 'flex',
        gap: 'var(--space-3)',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'wrap',
      }}
    >
      <span
        style={{ fontFamily: 'var(--font-family-display)', fontWeight: 700 }}
      >
        RUNEGAMBIT v1.3
      </span>
      <Chip>{locale.toUpperCase()}</Chip>
      <Btn
        kind="ghost"
        size="sm"
        onClick={() => navigateTo('/privacy')}
        testId="footer-privacy-link"
      >
        <FormattedMessage
          id="footer.privacy_link"
          defaultMessage="Privacy policy"
        />
      </Btn>
    </footer>
  )
}
